<template>
  <div class="upload" v-loading.fullscreen='loading'>
      <h3 class="title-group">5、上传素材</h3>
    <div class="tips mb20">
        <p class="text-color-gray">创建说明：将按照调用计划的规格（计划下组、广告、创意数量）匹配上传的创意，当上传的创意数量大于一个计划规格数量时，将创建第二个计划，以此类推。</p>
        <p class="text-color-gray">若不满足调用计划的规格，则满足哪个创意创建哪个创意。可在右侧预览批量创建后的规格。</p>
    </div>
    <FormBox
        ref="FormBoxRef"
        :appList="configAppList"
        :advGroup="advGroup"
        :config.sync="fileConfigList"
        :appName.sync="appName"
        @form-change="handleFormChange"
        :selectData="selectData"
    />
    <div class="mb20">
        <el-button type="primary" plain @click="handleAutoMatchOrder">自动匹配上传</el-button>
        <p class="text-color-gray">自动匹配上传：按照尺寸、大小、格式等其他要求，自动将素材匹配至当前产品下对应的广告组、展现形式、创意规格下。</p>
    </div>
    <div style="height: 850px">
        <UploadBox
            :config="fileConfigList"
            :currentKey="currentKey"
            :selectData="selectData"
            @update="handleUpdate"
            ref="upload-box"
        />
    </div>
    </div>
</template>

<script>
import API from '@/api/marketManage/vivoBatch';
import ListCheck from './listCheck.vue'
import FormBox from './formBox.vue'
import UploadBox from './uploadBox.vue'
import {  cloneDeep } from 'lodash'
import { autoMatchOrder, selectSizeModal } from '../../modal'
export default {
    name: 'UploadIdea',
    components: {
        ListCheck,
        FormBox,
        UploadBox
    },
    provide() {
        return {
            showPage:()=>this.isShow,
            getAppList: ()=>this.appList,
            hasAll: false,
            keyWords: '',
            ideaGlobal: this
        }
    },
    props: {
        app_list: {
            type: Array,
            default: ()=> [ 
                { "plat_id": "3", "app_id": "3334920", "app_name": "永恒仙域-山海异兽卡牌", "package_name": "com.xytf.yhxy.vivo", "app_type": "2", "package_type": "11", "project_id": "1806", "project_name": "永恒仙域", "main_app_name": "永恒仙域", "is_from_entry_app": "0", "customer_id": "3375", "checked": false }, { "plat_id": "3", "app_id": "3440477", "app_name": "永恒仙域-山海挂机仙侠", "package_name": "com.xytf.jz2yhxy.vivoad.vivo", "app_type": "2", "package_type": "11", "project_id": "1806", "project_name": "永恒仙域", "main_app_name": "永恒仙域", "is_from_entry_app": "0", "customer_id": "3375", "checked": false }, { "plat_id": "3", "app_id": "3398851", "app_name": "永恒仙域-山海挂机仙侠", "package_name": "com.xytf.yhxy2.vivo", "app_type": "2", "package_type": "11", "project_id": "1806", "project_name": "永恒仙域", "main_app_name": "永恒仙域", "is_from_entry_app": "0", "customer_id": "3375", "checked": false } 
            ]
        },
        planId: {
            type: [ String, Number ],
            default: '9802586' // 9802586 8519661  8360860  8384658 8519661
        },
        taskId: {
            type: [ String, Number ],
            default: '1301' //791 237 1006  1131 1142 1255
        },
        isShow: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
           advGroup: [],
           fileConfigList: [],
           selectData: {},
           currentKey: '',
           appId: '',
           appName: '',
           code_: '#*|||*#',// 下划线
           split_: '#*||*#',//横杠
           loading: false,
           searchConfigData: { material_status_map: [], plat_map: [] },
        }
    },
    computed: {
        appList() {
            return this.app_list.map(v=> {
                return {
                    ...v,
                    _package_name: v.package_name,
                    package_name: v.package_name.replaceAll('_', this.code_).replaceAll('-', this.split_)
                }
            })
        },
        configAppList() {
            return this.appList.map(v=> {
                return {
                    ...v,
                    value: `${v.package_name}`
                }
            })
        }
    },
    watch: {
        isShow(n) {
            // 可见
            if (n) {
                console.log(11111);
                this.getUploadConfig()
                this.getWorkOrderSearchConfig()
            }else {
                this.$bus.$emit('delconfigData');
            }
        },
        appList() {
            const package_names = this.appList.map(v=>v.package_name)
            this.selectData = Object.keys(this.selectData).reduce((pre, item)=> {
                const [package_name] = item.split('-');
                if (package_names.includes(package_name)) {
                    pre[item] = this.selectData[item]
                }
                return pre;
            }, {});
        }
    },
    created() {
        // this.getUploadConfig() //283046
    },
    methods: {
        async getWorkOrderSearchConfig() {
            const { data } = await API.getWorkOrderSearchConfig();
            this.searchConfigData = data;
        },
        async getUploadConfig() {
            try {
                const params = {
                    plan_id:this.planId,
                    task_id:this.taskId,
                }
               this.loading = true
                const { data } = await API.getUploadConfig(params);
                if (!data.length) {
                    this.$message.error('未获取到该计划下有效的创意数据');
                    return
                };
                this.advGroup = data.map(v=> {
                    return {
                        ...v,
                        value: v.group_id
                    }
                });
                this.$bus.$emit('updateListData');
                this.$nextTick(()=> {
                    this.handleFormChange(this.$refs.FormBoxRef.formData)
                })
            } catch (error) {
                this.$message.error(error.info)
            }finally {
                this.loading = false
            }
        },
        handleUpdate(list, key) {
            if (key) {
                this.selectData = {
                    ...this.selectData,
                    [key]: cloneDeep(list)
                } 
            }else {
                this.selectData = {
                    ...this.selectData,
                    [this.currentKey]: cloneDeep(list)
                }
            }
            this.$forceUpdate()
        },
        handleFormChange(form) {
            const { appId, groupId, displayId, normId  } = form || {}
            const key = `${appId}-${groupId}-${displayId}-${normId}`;
            this.appId = appId
            this.currentKey = key;
            let list = [];
            const data = this.selectData[key]
            if (data) {
                list = cloneDeep(data)
            }
            this.$refs['upload-box'].updateResultList(list)
        },
        handleAutoMatchOrder() {
            const advGroup = this.advGroup;
            const config = [];
            (function getConfig(list = advGroup, keys={path:[],key:[]}, type = 'group') {
                list.forEach(v=>{
                    let path_name = cloneDeep(keys) 
                    if (type === 'group') {
                       path_name.path.push(`广告组(${v.group_name})`)
                       path_name.key.push(v.group_id)
                    }else if(type = 'display'){
                        path_name.path.push(`展现形式(${v.display_type_text})`);
                        path_name.key.push(v.display_type)
                    }
                    if (v.norm_list) {
                        let arr = []
                        v.norm_list.forEach(v=>{
                            const path = [...path_name.path, `${v.norm_model_text}`];
                            const key = [ ...path_name.key, v.norm_model, v.norm_id ]
                            arr =arr.concat(v.config.map(v=> {
                                return {
                                    ...v,
                                    path: path.join(','),
                                    key: key.join('-')
                                }
                            }))
                        });
                        config.push(...arr);
                    }else {
                        getConfig(v.display_list, path_name, 'display')
                    }
                })
            })();
            const onSubmit = (data)=> {
                const resultDataList = [];
                const list = [ ...data ].filter(v=>{
                    if (v.to.length > 1) {
                        return true
                    }else {
                        if (v.to.length === 1) {
                            const { value } = v;
                            const [ data ] = v.to;
                            const keysList = this.getAppKey(data.key);
                            keysList.map(v=> {
                                resultDataList.push([{
                                    ...value,
                                    key: v
                                }, value.type, data])
                                // this.addResultData()
                            })
                        }else {
                            console.log('存在为空的数据，请检查');
                        }
                        return false
                    }
                     
                });
                const cb = ()=> {
                    this.addResultData(...resultDataList.shift(), ()=>{
                        if (resultDataList.length) {
                            cb()
                        }
                    })
                };
                resultDataList.length&&cb();
                const idsObs = {};
                const listData = list.reduce((pre, item)=>{
                    const id = item.to.map(v=>v.conf_m_id).join('-');
                    if (idsObs[id]) {
                        idsObs[id].values.push(item.value)
                    }else {
                        const data = {
                            id,
                            to: item.to,
                            values: [item.value]
                        };
                        idsObs[id] = data;
                        pre.push(data)
                    }
                    return pre;
                }, []);
               this.showNextSelectSizeModal(listData)
               vm.close()
            };
            const { vm } = autoMatchOrder({
                props: {
                    config,
                    groups: advGroup,
                    appName: this.appName,
                    appList: this.appList,
                    searchConfigData: this.searchConfigData
                },
                cbs: {
                    onSubmit
                }
            })
        },
        showNextSelectSizeModal(list) {
            if (!list.length) {
                return
            }
            const data = list.shift();
            if (data) {
                this.showSelectSizeModal(data, ()=> {
                    if (list.length) {
                        this.showNextSelectSizeModal(list)
                    }
                })
            }else {
                this.showNextSelectSizeModal(list)
            }
        },
        showSelectSizeModal(data, cb) {
            const onSubmit = (data)=> {
                const list = data.data;
                 const resultDataList = [];
                list.forEach(value=> {
                    data.value.map((info)=> {
                        const keysList = this.getAppKey(info.key);
                        keysList.map(v=> {
                            console.log(v, value, info, 'showSelectSizeModal');
                            resultDataList.push([{
                                ...value,
                                explicit_name: info.explicit_name,
                                key: v
                            }, value.type, info]) 
                           
                        })
                    })
                });
                 const cb = ()=> {
                    this.addResultData(...resultDataList.shift(), ()=>{
                        if (resultDataList.length) {
                            cb()
                        }
                    })
                }
                cb();
                vm.close()
            }
            const { vm } = selectSizeModal({
                props: {
                    selectData: data,
                },
                on: {
                   closed: ()=> {
                        cb&& cb()
                   }
                },
                cbs: {
                    onSubmit
                }
            })
        },
        addResultData(data, type ,info ={}, cb) {
            this.$refs['upload-box'].addResultData(data, type, info);
            this.$nextTick(()=> {
                cb&&cb()
            })
        },
        getAppKey(key) {
            // package_name
            return [this.appId].map(package_name=> {
                 const arr = key.split('-');
                const nom = arr.pop();
                const keys = [package_name];
                return `${keys.concat(arr).join('-')}_${nom}`
            })
        },
        getParamsData() {
            const data = cloneDeep(this.selectData);
            const package_names = this.appList.map(v=>v.package_name);
            const paramsData =  Object.keys(data).filter((key)=> {
                const [ package_name ] = key.split('-');
                return package_names.includes(package_name);
            }).reduce((pre, item)=> {
                const arrs = data[item];
                const key = item.replace(/_/g, '-').replaceAll('-', this.split_).replaceAll(this.code_ , '_')
                pre[key] =  arrs.map(v=> {
                    delete v.id;
                    return  Object.values(v)
                    .filter(item=>{
                        return !!item
                    })
                    .map(({ value_name,material_name, material_url, filePath , name }={})=> {
                            return {
                                value_name,
                                material_name: material_name || name, 
                                material_url : material_url || filePath
                            }
                        })
                })
                return pre;
            }, {});
            console.log(paramsData, data,'paramsData');
            return paramsData;
        }
    }
}
</script>

<style lang="scss" scoped>
.upload {

}
.title-group{
    font-size: 14px;
    margin-bottom: 20px;
}
</style>